/**
 * @desc 门店点评图片上传
 */

import { RequestConfig, request } from 'umi';

function req(useless?: any, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.HttpResponse>(
    `/storeapi/api/v3/store/review/images`,
    {
      method: 'post',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
